export const API_URL = process.env.REACT_APP_API_URL;
export const PUBLIC_API_URL = process.env.REACT_APP_PUBLIC_URL;
